<template>
  <div style="height: 100%;">
    <div class="lv1-row1">
      <!-- Row 1 -->
      <div class="nav-overlay"></div>
      <!-- Header -->
      <div class="row border-bottom">
        <div class="hamburg-menu mobile-show">
          <div class="button_container toggle">
            <span class="top"></span>
            <span class="middle"></span>
            <span class="bottom"></span>
          </div>
        </div>

        <nav class="navbar navbar-static-top ob-header" role="navigation" style="margin-bottom: 0">
          <div class="navbar-header col-xs-12 offset-0" style="position: fixed;">
            <ul class="headerStrip">

              <!-- company Name & Logo -->
              <div class="cmpdetails">
                  <p class="cmp">
                    <img alt="image" class="profile-pic pics" :src="CompanyProfilePic" />
                    <span class="textt" :title="companyDetails" style="font-size: larger;">
                      {{companyDetails}}
                    </span>
                  </p>
              </div>
              <!-- onblick logo -->
              <li class="logodetail">
                <div class="logoBlock">
                  <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/BWLogo.png`" />
                </div>
              </li>

              <!-- left side notification & dropdown -->
              <ul class="headerStrip leftdetail">
                <!-- !loggedInUserObj.SingleOrg -->
                <li style="float: left;" class="pL0">
                  <div class="logOut--headerSec">
                    <span v-if="currentRole != null && currentRole != '' && currentRole.Roles.length > 2">
                      Role :
                      <span style="padding:5px 5px;" v-if="currentRole.Roles && currentRole.Roles.length > 2"
                        :class="[{'badge':true}]"></span>
                      <ob-popover trigger="click" :options="{placement: 'bottom'}" ref="popover">
                        <div class="popper" style="width:155px !important">
                          <div>
                            <p style="text-align:left;padding:2px 3px 9px 3px;"><b>Switch to</b></p>
                            <p class="switch-role-list"
                              v-if="currentRole.Roles && currentRole.Roles.indexOf('HRManager') > -1">
                              <span @click="updateChangeRoleSignal('HRManager')">HR Manager</span>
                            </p>
                            <p class="switch-role-list"
                              v-if="currentRole.Roles && currentRole.Roles.indexOf('Admin') > -1">
                              <span @click="updateChangeRoleSignal('Admin')">Admin</span>
                            </p>
                            <p class="switch-role-list"
                              v-if="currentRole.Roles && currentRole.Roles.indexOf('AccountManager') > -1">
                              <span @click="updateChangeRoleSignal('AccountManager')">Account Manager</span>
                            </p>
                            <p class="switch-role-list"
                              v-if="currentRole.Roles && currentRole.Roles.indexOf('Recruiter') > -1">
                              <span @click="updateChangeRoleSignal('Recruiter')">Recruiter</span>
                            </p>
                          </div>
                        </div>
                        <span slot="reference">
                          <span style="cursor:pointer;padding:5px 5px;" :class="[{'badge':true}]">Employee</span>
                          <i class="fa fa-chevron-down" aria-hidden="true"
                            style="padding-left: 5px;cursor:pointer;"></i>
                        </span>
                      </ob-popover>
                    </span>
                  </div>
                </li>
                <li class="namedetail" style="float: left;width: 9%;" v-if="organizationCount > 1">
                  <div style="padding-top: 6px;position: fixed;margin-left: -6%;">
                    <a style="padding-right: 1px;margin-left: 39px" class="right-sidebar-toggle logOut--SettingR">
                      <ob-popover trigger="click" :options="{placement: 'bottom'}" ref="popover">
                        <div class="popper popOrg">
                          <div class="popper-section">
                            <p class="pop-para">Switch to</p>
                            <ul v-for="(orgRec,index) in orgInfo" class="org"
                              v-if="!(orgRec.Id == loggedInUserObj.orgId)" :key="index">
                              <div class="org-icon">
                                <img v-if="orgRec.IsEssValidated" @click="SelectOrg(orgRec)"
                                  :src="orgRec.LogoLink == null || orgRec.LogoLink == '' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/large.svg` : orgRec.LogoLink"
                                  alt="organization-logo" height="30px" width="30px" />
                                <img v-else
                                  :src="orgRec.LogoLink == null || orgRec.LogoLink == '' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/large.svg` : orgRec.LogoLink"
                                  alt="organization-logo" height="30px" width="30px" />
                              </div>
                              <div style="padding-top:6px">
                                <p :title="orgRec.Name" v-if="orgRec.IsEssValidated" @click="SelectOrg(orgRec)"
                                  style="width:190px" class="org-text">{{orgRec.Name.length > 20 ? orgRec.Name.substr(0,
                                  19)+"..." : orgRec.Name}}</p>
                                <p :title="orgRec.Name" v-else class="org-text">
                                  <span
                                    style="width:150px;color:#143361!important;font-size: 13px;font-weight: 600;">{{orgRec.Name.length
                                    > 15 ? orgRec.Name.substr(0, 14)+"..." : orgRec.Name}}</span>
                                  <ob-button @click="verifyPopup(orgRec)" style="padding: 2px 10px;float:right">Verify
                                  </ob-button>
                                </p>
                              </div>
                            </ul>
                          </div>
                        </div>
                        <button v-if="organizationCount > 1" class="btn btn-default" slot="reference"
                          style="background-color:transparent;">
                          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_switch.svg`" aria-hidden="true"
                            style="position:relative;" />
                        </button>
                      </ob-popover>
                    </a>
                  </div>
                </li>
                  <!-- Notification Bell -->
                <li style=" padding-top: 4%;">
                  <div class="logOut--headerSec" style="margin: 0; padding-top: 5px;">
                    <a class="right-sidebar-toggle logOut--SettingR" @click="showNotificationBell = !showNotificationBell" v-click-outside="closeNotificationBell">
                      <i class="fa fa-bell-o" aria-hidden="true"></i>
                      <span class="Alert--fill" :class="{'show-notification-count': parseInt(notificationCount) > 0}">{{notificationCount}}</span>
                    </a>
                  </div>
                </li>

                <!-- NEW -->
                <li class="side-nav-profile-pic namedetail">
                  <a  class="anchordetail">

                    <ob-popover trigger="click" :options="{placement: 'bottom'}" ref="popover" style="background-color: rgba(0, 0, 0, 0);">
                      <div class="popper popTop">
                        <div>
                          <p class="switch-role-list-popover" >
                            <span class="drop">
                              <li style="padding-bottom: 10px;" :class="{'active': $route.name == 'employee-profile'}">
                                <router-link :to="routeToProfile" :class="{'router-link-exact-active router-link-active':$route.name == 'employee-profile'}">
                                  Update Profile
                                </router-link>
                              </li>
                            </span>
                          </p>
                          <p class="switch-role-list-popover">
                            <!-- <i class="fa fa-sign-out" aria-hidden="true"></i> -->
                            <span class="drop" @click="onSignOut">Sign Out</span>
                          </p>
                        </div>
                      </div>
                      <span slot="reference">
                        <span class="nav-icon profilepics" id="auto_load_div">
                          <img alt="image" class="profile-pic picc" :src="profilePic" />
                        </span>
                        <span class="nameDesignation" :class="[{'badge':true}]">
                          <span>
                            <div style="padding-bottom: 3px;" :title="name" class="ellipsis-text">{{name}}</div>
                            <div :title="designation" class="ellipsis-designtn" style="color: #C4C9D1;background-color: rgba(0, 0, 0, 0);text-align: left;">{{designation}}</div>
                          </span>
                        </span>
                        <i class="fa fa-chevron-down" aria-hidden="true" style="padding-left: 5px;cursor:pointer;"></i>
                      </span>
                    </ob-popover>
                  </a>
                  <!-- <div class="logo-element" id="auto_response_div"></div> -->
                </li>


              </ul>
            </ul>
          </div>
        </nav>
      </div>
      <div class="right-sidebarMT"></div>
      <!--// Header -->
    </div>

    <div class="lv1-row2">
      <!-- Row 2-->
      <!-- Side Nav -->
      <nav class="side-nav">
        <div class="side-bar">
          <ul class="top">
            <li :class="{'active': $route.name == 'ess-dashboard'}">
              <router-link :to="{name: 'ess-dashboard'}">
                <span class="nav-icon ob__Img ob-dashboard__Img"></span>
                <span class="nav-label">Dashboard</span>
              </router-link>
            </li>
            <li :class="{'active': $route.name == 'employee-details'}">
              <router-link :to="{name: 'employee-details'}">
                <span class="nav-icon ob__Img ob-profile__Img"></span>
                <span class="nav-label">Profile</span>
              </router-link>
            </li>
            <li
              v-if="(empData.HireType == 'W2') && (empData.IsH1B || empData.WorkPermit == 'OPT EAD' || empData.WorkPermit == 'CPT' || empData.WorkPermit == 'STEM OPT' || empData.WorkPermit == 'EAD OTHERS')"
              :class="{'active': $route.name == 'ess-fdns-visit-question'}">
              <router-link :to="{name: 'ess-fdns-visit-question'}">
                <span class="nav-icon ob__Img ob-fdns__Img"></span>
                <span class="nav-label">FDNS Visit</span>
              </router-link>
            </li>
            <li :class="{'active': $route.name == 'evaluation' ||  $route.name == 'employee-tasks'}">
              <router-link :to="{name: 'evaluation'}">
                <span class="nav-icon ob__Img ob-evaluation__Img"></span>
                <span class="nav-label">Evaluation/Tasks</span>
              </router-link>
            </li>
            <li v-if="IsSupervisor" class="reportingClass"
              :class="{'active': $route.name == 'ReportingEmployees' || $route.name == 'supervisor-form-i983' || $route.name == 'employee-tasks-trainee' || $route.name == 'employee-evaluation-trainee' || $route.name == 'employee-LeaveReport-trainee'}">
              <router-link :to="{name: 'ReportingEmployees'}">
                <span class="nav-icon ob__Img ob-workforce__Img"></span>
                <span class="nav-label" style="padding-left: 0px; margin-left: -4px">Reporting Employees/Trainees</span>
              </router-link>
            </li>
            <li v-if="IsSupervisor"
              :class="{'active': $route.name == 'employer-timesheets' ||  $route.name == 'my-timesheets'}">
              <router-link :to="{name: 'employer-timesheets'}">
                <span class="nav-icon ob__Img ob-timesheets__Img"></span>
                <span class="nav-label">{{ timesheetLabel }}</span>
              </router-link>
            </li>
            <li :class="{'active': $route.name == 'my-timesheets' ||  $route.name == 'employer-timesheets'}" v-else>
              <router-link :to="{name: 'my-timesheets'}">
                <span class="nav-icon ob__Img ob-timesheets__Img"></span>
                <span class="nav-label">{{ timesheetLabel }}</span>
              </router-link>
            </li>
            <li
              :class="{'active': $route.name == 'leave-management' || $route.name == 'leave-count' || $route.name == 'leave-history' || $route.name == 'leave-policy' || $route.name == 'holiday-list'}">
              <router-link :to="{name: 'leave-management'}">
                <span class="nav-icon ob__Img ob-leave-management__Img"></span>
                <span class="nav-label">Leave Management</span>
              </router-link>
            </li>
            <li :class="{'active': $route.name == 'employee-profile'}">
              <router-link :to="{name: 'employee-profile'}">
                <span class="nav-icon ob__Img ob-settings__Img"></span>
                <span class="nav-label">Settings</span>
              </router-link>
            </li>
          </ul>
          <ul class="bottom">
            <li>
              <div title="OnBlick Inc.," style="text-align: center;border-top: 1px solid #87898B;padding: 10px 0;">
                <div style="font-size: 22px;">&copy;</div>
                <div style="display: block;">{{date}}</div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <!--// Side Nav -->
      <!-- Main Content -->
      <div class="main-content">
        <slot></slot>
      </div>
    </div>
    <notifications group="custom-template" :duration="-1" :width="540" animation-name="v-fade-left"
      position="bottom left" style="left:85px" :max="4">
      <template slot="body" slot-scope="props">
        <custom-notification :props="props"></custom-notification>
      </template>
    </notifications>
    <profile-pic-modal :openModal.sync="openprofilemodal" :orgId="orgId"></profile-pic-modal>
    <transition name="slide-fade">
      <notification-bell :show.sync="showNotificationBell" v-if="showNotificationBell"></notification-bell>
    </transition>
    <verify-phone-popup :openModal.sync="openPhonemodal" :EmployeeId="empId" :PhoneNo="phone" :OrgName="orgName">
    </verify-phone-popup>
    <disabled-organization :openModal.sync="openAlertmodal" :OrgName="disableOrg"></disabled-organization>
    <ob-timesheet-status-progress ref="draggablTimesheetReportProgress"></ob-timesheet-status-progress>
    <ob-modal2 :show.sync="showSwitchRoleNotify" size="md">
      <template slot="modal-title">
        Success
      </template>
      <template slot="modal-body">
        <div class="switch-role-popup role-change-sucess text-center">
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/success_icon.png`" class="switch-change-icon">
          <h2>Role change complete</h2>
          <input type="hidden" id="currentRole" name="currentRole">
          <input type="hidden" id="newRole" name="newRole">
          <p>You are viewing the HR dashboard now, you can switch back to another role by clicking on Switch roles in
            the settings.</p>
        </div>
      </template>
      <template slot="modal-footer">
        <ob-button @click="showSwitchRoleNotify = false">OK</ob-button>
      </template>
    </ob-modal2>
    <ob-modal2 :show.sync="roleChangeNotification" :backdrop="false" size="md">
      <template slot="modal-title">
        Success
      </template>
      <template slot="modal-body">
        <div class="switch-role-popup role-change-sucess text-center">
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/success_icon.png`" class="switch-change-icon">
          <h2>Role changed</h2>
          <p>Someone with same credentials in another system has changed role.</p>
          <p>Do you wish to continue?</p>
        </div>
      </template>
      <template slot="modal-footer">
        <form :action="switchRolePostURL" ref="roleChangeNotificationForm" role="form" method="post"
          @submit="$loading('Switching the role...')">
          <div v-html="loggedInUserObj.AntiForgeryToken"></div>
          <input type="hidden" id="prevRole" name="prevRole" />
          <input type="hidden" id="existingRole" name="existingRole" />
          <input type="hidden" id="connectionId" name="connectionId" />
          <input type="hidden" id="isRetain" name="isRetain" value=false />
          <input type="hidden" id="employeeId" name="employeeId" v-model="employeeId" />
          <ob-button @click="retainRoleChange">Retain</ob-button>
          <ob-button @click="continueRoleChange">Continue</ob-button>
        </form>
      </template>
    </ob-modal2>
    <form id="roleChange" :action="switchRoleURL" method="post" @submit="$loading('Switching the role...')">
      <div v-html="loggedInUserObj.AntiForgeryToken"></div>
      <input type="hidden" id="presentRole" name="currentRole" v-model="role" />
      <input type="hidden" id="selectedRole" name="newRole" value="" />
      <input type="hidden" id="employeeId" name="employeeId" v-model="employeeId" />
      <!-- <input type="hidden" id="connectionId" name="connectionId" v-model="connectionId" /> -->
    </form>
  </div>
</template>

<script>
import c from "Vue/Core/constants.js";
import profileModal from "@/components/ESSProfile/ESSSettings/ProfilePicModal.vue";
import jquery from 'jquery';
import verifyPhoneModal from "@/components/verifyPhonePopup.vue";
import disabledOrganizationModal from "@/components/DisabledOrganization.vue";
import NotificationBell from "@/components/ESSProfile/Notification/NotificationBell.vue";
import CustomNotification from "@/components/ESSProfile/Notification/CustomNotification.vue";
import { initSession } from 'Vue/Core/session-manager.js'

export default {
  name: "BaseLayout",
  data() {
    return {
      routeToProfile: {
        name: "employee-profile",
        query: this.$route.query
      },
      dropdownVisible: false,
      companyDetails:"",
      companyLogo: "",
      date: new Date().getFullYear(),
      currentRole: '',
      openprofilemodal: false,
      empData: "",
      empInfo: "",
      orgInfo: "",
      openPhonemodal: false,
      empId: "",
      orgId: "",
      phone: "",
      //Otp:'',
      organizationCount: 0,
      orgName: "",
      openAlertmodal: false,
      disableOrg: "",
      IsSupervisor: "",
      //count:''
      showNotificationBell: false,
      role: 'Employee',
      showSwitchRoleNotify: false,
      // switchRolePostURL: `${c.WSO2BASEURL}/Account/UpdateClaimsAfterChangeRole`,
      roleChangeNotification: false,
    };
  },
  components: {
    "profile-pic-modal": profileModal,
    "verify-phone-popup": verifyPhoneModal,
    "disabled-organization": disabledOrganizationModal,
    "notification-bell": NotificationBell,
    "custom-notification": CustomNotification
  },
  created() {
    session.isActive()
    this.timeItervalforSnooze()
    this.$store.commit('updateEmployeeOrgId', this.loggedInUserObj.orgId)
    this.getCurrentRole();
    this.$store.dispatch('fetchUnreadNotificationsCount', 'dfg');
    //this.count = this.organizationCount
    // if(!loggedInUserObj.SelectOrg){
    //   this.getESSEnabledOrg()
    // }
    this.getProfile()
    this.fetchTimesheetModuleName();
    events.listen('profileUpdate', () => {
      this.getProfile()
    })
    events.listen('profileRemoved', () => {
      this.getProfile()
    })
    this.organizationList()
    events.listen('verificationSuccess', () => {
      this.organizationList()
    })
    this.isSupervisor()


    if (this.$route.query && this.$route.query.isRoleChangeInitiatedFromClient && this.$route.query.isRoleChangeInitiatedFromClient != '') {
      var newurl = window.location.href;
      if (newurl.indexOf('?isRoleChangeInitiatedFromClient=Yes') > -1 || newurl.indexOf('&isRoleChangeInitiatedFromClient=Yes') > -1) {
        newurl = newurl.replace("?isRoleChangeInitiatedFromClient=Yes", "").replace("&isRoleChangeInitiatedFromClient=Yes", "")
        window.history.pushState({ path: newurl }, '', newurl);
      }
      localStorage.setItem('changeRoleSignalReceived', "false")
      localStorage.removeItem("changeRoleSignalObj")
    }
    else if (localStorage.getItem('changeRoleSignalReceived') == "true") {
      var obj = JSON.parse(localStorage.getItem('changeRoleSignalObj'));
      if (obj != null) {
        this.$refs.roleChangeNotificationForm.elements.prevRole.value = obj.PreviousRole
        this.$refs.roleChangeNotificationForm.elements.existingRole.value = obj.CurrentRole
      }
      this.roleChangeNotification = true
    }

    events.listen('rolechanged', (obj) => {
      this.$refs.roleChangeNotificationForm.elements.prevRole.value = 'HRManager'
      this.$refs.roleChangeNotificationForm.elements.existingRole.value = obj
      this.roleChangeNotification = true
    })

  },
  computed: {

    notificationCount() {
      return this.$store.getters.getUnreadNotificationsCount;
    },

    employeeId() {
      return loggedInUserObj.empId || "";
    },

    name() {
      // return loggedInUserObj.name || "";
      return this.empData.Name || "";
    },
    switchRoleURL() {
      return `${c.WSO2BASEURL}/Account/SwitchRole`
    },
    switchRolePostURL() {
      return `${c.WSO2BASEURL}/Account/UpdateClaimsAfterChangeRole`
    },
    timesheetLabel() {
      return this.$store.getters.getTimesheetModuleName;
    },
    designation() {
      // return loggedInUserObj.designation || "Consultant";
      return this.empData.Designation || "Consultant";
    },
    profilePic() {
      if (
        this.empData.ProfilePicLink != "" &&
        this.empData.ProfilePicLink != null
      )
        return this.empData.ProfilePicLink;
      else return `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`;
    },
    CompanyProfilePic() {
      if (
        this.companyLogo != "" &&
        this.companyLogo != null
      )
        return this.companyLogo;
      else return `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`;
    },
    consultantDetails: {
      get() {
        return this.$store.getters.getConsultantDetails;
      },
      set(value) {
        this.$store.commit("updateConsultantDetails", value);
      }
    },
    /* isH1B(){
      return loggedInUserObj.isH1B
    },
    isW2(){
      return loggedInUserObj.HireType =="W2"
    }, */
    // isSupervisor(){
    //   return this.empData.IsSupervisor
    // },
  },
  mounted() {
    if (session.isTimeOutSet == false) {
      initSession();
    }
    bus.listen("showSnoozeNotificationListener1", (obj) => {
      //this.showSnoozeNotification(obj)
      this.triggerSnoozePopup(obj);
    })
    bus.listen("AddSoozeDateTimeSignalListener", (count) => {
      this.NotificationForMoreCount(count)
    })
    bus.listen("AddSoozeDateTimeSignalListener", (obj) => {
      this.AddAddSoozeDateTimeSignal(obj)
    })


    if (this.$route.query.isRoleChangeInitiatedFromClient == 'Yes') {
      this.showSwitchRoleNotify = true;
    } else {
      this.showSwitchRoleNotify = false;
    }

    bus.listen("roleChangeListener_v1", (obj) => {
      if (localStorage.getItem('roleChangeInitiated') !== "true") {
        this.$refs.roleChangeNotificationForm.elements.prevRole.value = obj.PreviousRole
        this.$refs.roleChangeNotificationForm.elements.existingRole.value = obj.CurrentRole

        localStorage.setItem('changeRoleSignalObj', JSON.stringify(obj));
        this.roleChangeNotification = true

        var queryParams = (new URL(document.location)).searchParams;
        var isSwitchRoleChangeFromThisClient = queryParams.get("isRoleChangeInitiatedFromClient")
        if (!(isSwitchRoleChangeFromThisClient != null && isSwitchRoleChangeFromThisClient != ''))
          localStorage.setItem('changeRoleSignalReceived', "true")
      }
      else {
        this.roleChangeNotification = false
        localStorage.setItem('changeRoleSignalReceived', "false")
        localStorage.removeItem("changeRoleSignalObj")
        localStorage.setItem('roleChangeInitiated', "false")
      }
    })
  },
  methods: {


    onUpdateProfile(){
      this.$router.push('/settings');
    },
    timeItervalforSnooze() {
      let interval = setInterval(() => {
        var details = JSON.parse(localStorage.getItem('Cached_Alert_List'))

        if (details != null) {
          this.showSnoozNotification(details, 0)
        }
      }, 60 * 1000);
    },
    getCurrentRole() {
      ajax.get("GetBasicUserInfo", {}, (res) => {
        if (res.data.State == true) {
          this.currentRole = res.data.UserAccount
          if (res.data.UserAccount != null && res.data.UserAccount.CurrentRole == "HRManager") {
            this.onSignOut()
          }
        }
      })
    },
    updateChangeRoleSignal(val) {
      this.$loading({ 'loadingText': 'Switching the Role...' })
      document.getElementById("selectedRole").value = val
      //Console.log("Current Role :", this.loggedInUserObj.Role, "Selected Role :", val)
      localStorage.setItem('changeRoleSignalReceived', "false")
      localStorage.setItem('roleChangeInitiated', "true")
      jquery("#roleChange").submit()
    },
    showSnoozNotification(details, i) {
      var snoozeDate = moment(details[i].SnoozeDateTime).local().format("YYYY-MM-DD HH:mm");
      var currenDate = moment().format("YYYY-MM-DD HH:mm");

      var fDate = moment().subtract(30, 'seconds').format("YYYY-MM-DD HH:mm");
      var tDate = moment().add(30, 'seconds').format("YYYY-MM-DD HH:mm");

      let _isBetween = moment(snoozeDate).isBetween(fDate, tDate, null, '[]')

      if (_isBetween) {
        ajax.put(`Compliance/IsAlertActionPerformed?alertId=${details[i].SnoozeModel.Id}`, {}, res => {
          let isAlertExist = res.data.State;
          if (isAlertExist) {
            var obj = {};
            obj["SnoozeModel"] = []
            obj.SnoozeModel.push(details[i].SnoozeModel)
            this.showSnoozeNotificationPopup(obj)
            var list = details.filter(x => { return x.Id != details[i].Id })
            details = list;
            const parsedList = JSON.stringify(list);
            localStorage.setItem('Cached_Alert_List', parsedList);
          }
          i = i + 1;

          if (details.length > i) {
            this.showSnoozNotification(details, i++);
          }
        })
      }
      else {
        i = i + 1;
        if (details.length > i) {
          this.showSnoozNotification(details, i++);
        }
      }
    },
    AddSnoozedDateFromBasicDetails(data) {
      localStorage.removeItem("Cached_Alert_List");
      if(data){
      for (var i = 0; i < data.length; i++) {
        this.AddAddSoozeDateTimeSignal(data[i]);
        }
      }
    },
    AddAddSoozeDateTimeSignal(obj) {
      var CachedAlertList = [];
      var details = JSON.parse(localStorage.getItem("Cached_Alert_List"));
      if (details != null) {
        var list = details.filter(x => {
          return x.Id != obj.Id;
        });
        CachedAlertList = list;
      }
      CachedAlertList.push(obj);
      const parsed = JSON.stringify(CachedAlertList);
      localStorage.setItem("Cached_Alert_List", parsed);
    },
    NotificationForMoreCount(count) {
      var notificationData = {
        count: count,
        Type: "MoreCount"
      };
      this.$notify({
        group: "custom-template",
        data: notificationData
      });
    },
    triggerSnoozePopup(notificationData) {
      this.$notify({
        group: "custom-template",
        data: notificationData
      });
    },
    showSnoozeNotification(obj) {
      this.showSnoozeNotificationPopup(obj);
    },
    showSnoozeNotificationPopup(obj) {
      this.triggerSnoozePopup(obj.SnoozeModel[0]);
      var i = 0;
      let interval = setInterval(() => {
        i++;
        if (i < 3) {
          this.triggerSnoozePopup(obj.SnoozeModel[i]);
        } else if (i == 3 && obj.count > 3) {
          this.NotificationForMoreCount(obj.count - 3);
        } else if (i > 4) {
          clearInterval(interval);
        }
      }, 10000);
    },
    isSupervisor() {
      ajax.get(
        `Supervisor/IsSupervisor?empId=${loggedInUserObj.empId}`,
        {},
        res => {
          if (res.data) this.IsSupervisor = res.data;
        }
      );
      return this.IsSupervisor;
    },

    // getESSEnabledOrg(){
    //   ajax.get(`/Employee/${loggedInUserObj.email}/OnBordedOrganizations`, {}, (res) => {
    //       if(res.data.State == true){
    //         var employeeOrganizations = res.data.EmployeeOrganizations
    //         var count = 0;
    //         var obj = {};

    //         var orgId='';
    //
    //         //console.log(employeeOrganizations.filter((d) => { return d.IsESSEnabled}))

    //         if(employeeOrganizations != null && employeeOrganizations != ''){
    //           employeeOrganizations.forEach((e)=>{
    //             if(e.IsESSEnabled)
    //               count +=1;
    //           })
    //           console.log(this.organizationCount, "oaiuytryuioo")
    //           if (count == 0){
    //               this.onSignOut()
    //           }
    //           else if(count == 1){
    //               obj = employeeOrganizations.filter((d) => { if(d.IsESSEnabled == true) return d})
    //                if(obj[0].IsEssValidated == true){
    //                   this.$loading({ 'loadingText': 'Loading...' })
    //                   ajax.get(`/Employee/GetEmployeeDetails?orgId=${obj[0].Id}`, {}, (res) => {
    //                     var userObj = {}
    //                     userObj.empId = res.data.EmpId
    //                     userObj.name = res.data.EmployeeContact.FirstName + ' ' + res.data.EmployeeContact.LastName
    //                     userObj.email = res.data.EmployeeContact.Email
    //                     userObj.orgId = res.data.OrgId
    //                     userObj.consultantId = res.data.ConsultantId
    //                     userObj.profilepic = res.data.ProfilePicLink
    //                     userObj.designation = res.data.Designation
    //                     userObj.IsH1B = res.data.IsH1B
    //                     userObj.OrgName = res.data.OrgName
    //                     userObj.OrgWebSite = res.data.OrgWebsite
    //                     userObj.HireType = res.data.HireType
    //                     userObj.SelectOrg = "multiple"
    //                     // Update the employee details in local storage
    //                     localStorage.setItem("user_details", JSON.stringify(userObj))
    //                     // update the employee details
    //                     ajax.updateUserDetails()
    //                     this.$router.push({'name':'employee-details'})
    //                     this.$loading({}).close()
    //                   })
    //                }
    //                else{
    //                    this.$router.push({'name':'SelectOrganization'})
    //                }
    //           }
    //           else if( count > 1 ){
    //             var obj1 = [];
    //             var countD = 0;
    //             //select organization page
    //              obj1 = employeeOrganizations.filter((d) => { if(d.IsESSEnabled == true) return d})
    //               obj1.forEach((e)=>{
    //                   if(e.IsEssValidated){
    //                   console.log(e,"prathibha")
    //                     countD +=1;
    //                   }
    //                   //orgId = e.Id
    //               })
    //               if(countD == 1){
    //                   obj1.forEach((e)=>{
    //                     if(e.IsEssValidated)
    //                       orgId = e.Id
    //                   })
    //                this.$loading({ 'loadingText': 'Loading...' })
    //                   ajax.get(`/Employee/GetEmployeeDetails?orgId=${orgId}`, {}, (res) => {
    //                     var userObj = {}
    //                     userObj.empId = res.data.EmpId
    //                     userObj.name = res.data.EmployeeContact.FirstName + ' ' + res.data.EmployeeContact.LastName
    //                     userObj.email = res.data.EmployeeContact.Email
    //                     userObj.orgId = res.data.OrgId
    //                     userObj.consultantId = res.data.ConsultantId
    //                     userObj.profilepic = res.data.ProfilePicLink
    //                     userObj.designation = res.data.Designation
    //                     userObj.IsH1B = res.data.IsH1B
    //                     userObj.OrgName = res.data.OrgName
    //                     userObj.OrgWebSite = res.data.OrgWebsite
    //                     userObj.HireType = res.data.HireType
    //                     userObj.SelectOrg = "multiple"
    //                     // Update the employee details in local storage
    //                     localStorage.setItem("user_details", JSON.stringify(userObj))
    //                     // update the employee details
    //                     ajax.updateUserDetails()
    //                     this.$router.push({'name':'employee-details'})
    //                     this.$loading({}).close()
    //                   })
    //               }
    //               else if(!loggedInUserObj.SelectOrg)
    //                 this.$router.push({'name':'SelectOrganization'})
    //           }
    //         }
    //       }
    //   })

    // },
    fetchTimesheetModuleName() {
      if (!this.loggedInUserObj || !this.loggedInUserObj.orgId) {
        return;
      }
      ajax.get(`TimeSheets/ModuleName?orgId=${this.loggedInUserObj.orgId}`, {}, (res) => {
        if (res.data && res.data.State === true && res.data.ModuleName) {
          const label = res.data.ModuleName || 'Timesheets';
          this.$store.commit('updateTimesheetModuleName', label);
        }
      }, (error) => {
        // On error, keep default 'Timesheets'
        console.warn('Failed to fetch timesheet module name, using default');
      });
    },
    getProfile() {
      //this.$loading({ loadingText: "Loading..." });
      ajax.get(`/Employee/${loggedInUserObj.empId}/BasicInfo`, {}, res => {
        if (res.data.State == true) {
          this.empData = res.data.Employee;
          this.consultantDetails = res.data.Employee
          var userDetails = localStorage.getItem("user_details");
          if (userDetails) {
            userDetails = JSON.parse(userDetails);
            userDetails.IsH1B = this.empData.IsH1B;
            userDetails.IsSupervisor = this.empData.IsSupervisor;
            localStorage.setItem("user_details", JSON.stringify(userDetails));
            this.AddSnoozedDateFromBasicDetails(this.empData.SnoozedAlerts);
          }
          //this.phone = this.empData.Phone
        } else {
          this.ESSEnableDisable(res);
        }
      });
    },
    setProfile() {
      this.orgId = loggedInUserObj.orgId;
      this.openprofilemodal = true;
    },
    onSignOut() {
      ajax.signOut()
      // localStorage.removeItem("access_token");
      // localStorage.removeItem("user_details");

      // this.$router.push({ name: "LoginPage" });
    },
    organizationList() {
      ajax.get(
        // `Employee/${loggedInUserObj.email}/EmployeeOrganizationList`,
        `Employee/${loggedInUserObj.consultantId}/EmployeeOrganizationList`,
        {},
        res => {
          if (res.data.State == true) {

            this.empInfo = res.data.organizationBasicInfoList.EmployeeInfo;
            this.orgInfo = res.data.organizationBasicInfoList.OrganizationInfo;
            let selectedOrg = this.orgInfo.filter(x => x.Id == this.loggedInUserObj.orgId)[0];
            this.companyDetails = selectedOrg.Name
            this.companyLogo = selectedOrg.LogoLink
            if (this.orgInfo != null && this.orgInfo != "") {
              this.organizationCount = this.orgInfo.length;
              // var userDetails =  JSON.parse(localStorage.getItem('user_details'))
              // userDetails.SelectOrg = false
              // localStorage.setItem("user_details", JSON.stringify(userDetails))
              // ajax.updateUserDetails()
            }
          } else {
            this.ESSEnableDisable(res);
          }
        }
      );
    },
    verifyPopup(orgRec) {
      this.empId = orgRec.EmployeeId;
      this.orgName = orgRec.Name;
      this.phone = orgRec.Phone;
      this.$loading({ loadingText: "Loading..." });
      ajax.get(`Employee/${this.empId}/SendOTPToEmployee`, {}, res => {
        this.$loading({}).close();
        if (res.data.State == true) {
          this.openPhonemodal = true;
          //this.Otp = "OTP sent to your registered mobile number"
        } else {
          this.ESSEnableDisable(res);
          //this.Otp = "OTP sent failed"
        }
      });
    },
    SelectOrg(orgRec) {
      this.$loading({ loadingText: "Loading..." });
      ajax.get(`/Employee/${orgRec.EmployeeId}/IsESSEnabled`, {}, res => {
        if (res.data == false) {
          this.$loading({}).close();
          this.disableOrg = orgRec.Name;
          this.openAlertmodal = true;
        } else {
          ajax.get(
            `/Employee/GetEmployeeDetails?orgId=${orgRec.Id}`,
            {},
            res => {
              if (res.data.State == true) {
                var userObj = {};
                userObj.empId = res.data.EmpId;
                userObj.name =
                  res.data.EmployeeContact.FirstName +
                  " " +
                  res.data.EmployeeContact.LastName;
                userObj.email = res.data.EmployeeContact.Email;
                userObj.orgId = res.data.OrgId;
                userObj.consultantId = res.data.ConsultantId;
                userObj.profilepic = res.data.ProfilePicLink;
                userObj.designation = res.data.Designation;
                userObj.IsH1B = res.data.IsH1B;
                userObj.OrgName = res.data.OrgName;
                userObj.OrgWebSite = res.data.OrgWebsite;
                userObj.HireType = res.data.HireType;
                //userObj.SelectOrg = true
                // Update the employee details in local storage
                localStorage.setItem("user_details", JSON.stringify(userObj));
                // update the employee details
                ajax.updateUserDetails();
                window.location.replace(
                  c.APPLICATIONBASEURL + "/ess-dashboard"
                );
                this.$loading({}).close();
                // redirect to page
                //this.redirectToPage()
              } else {
                this.$loading({}).close();
                this.ESSEnableDisable(res);
              }
            }
          );
        }
      });
    },
    closeNotificationBell() {
      this.showNotificationBell = false;
    },
    retainRoleChange() {
      this.roleChangeNotification = false
      this.$loading({ loadingText: "Loading..." });
      this.$refs.roleChangeNotificationForm.elements.isRetain.value = true

      var prevRole = this.$refs.roleChangeNotificationForm.elements.prevRole.value

      this.$refs.roleChangeNotificationForm.elements.prevRole.value = this.$refs.roleChangeNotificationForm.elements.existingRole.value
      this.$refs.roleChangeNotificationForm.elements.existingRole.value = prevRole

      if ($.connection != null && $.connection.notificationHub != null) {
        this.$refs.roleChangeNotificationForm.elements.connectionId.value = $.connection.notificationHub.connection.id
        var loggedInUserObj = JSON.parse(localStorage.getItem('user_details'));
        loggedInUserObj.signalrConnectionId = $.connection.notificationHub.connection.id
        loggedInUserObj.changeRoleSignalReceived = false;
        localStorage.setItem('user_details', JSON.stringify(loggedInUserObj));
      }
      else {
        localStorage.setItem('changeRoleSignalReceived', "false")
      }
      this.$refs.roleChangeNotificationForm.submit();

    },
    continueRoleChange() {
      this.roleChangeNotification = false
      this.$loading({ loadingText: "Loading..." });
      if ($.connection != null && $.connection.notificationHub != null) {
        var loggedInUserObj = JSON.parse(localStorage.getItem('user_details'));
        loggedInUserObj.signalrConnectionId = $.connection.notificationHub.connection.id
        localStorage.setItem('user_details', JSON.stringify(loggedInUserObj));
      }
      this.$refs.roleChangeNotificationForm.elements.isRetain.value = false
      localStorage.setItem('changeRoleSignalReceived', "false")
      this.$refs.roleChangeNotificationForm.submit()
    },
  }
};
</script>
<!-- Layout update styles -->
<style lang="scss">
@import '../../static/Css/Content/SCSS/post-login-scss/scss/_cdnVariables.scss';
.customDropdown > .btn {
  background: none !important;
  color: white !important;
}
.drop a{
  color: black;
}

.drop a:hover{
  color: #ef032e;
}

.popper__arrow{
  left: 43% !important;
}

body {
  background: #f6f7f8;
}

.lv1-row1 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
}

.lv1-row2 {
  height: 100%;
  position: relative;
}

.lv1-row2 .side-nav {
  position: fixed;
  top: 0;
  bottom: 0;
  margin-top: 51px;
}

/* .lv1-row2 .main-content {
  width: calc(100% - 70px);
  margin: 20px 0 0 70px;
  padding: 15px;
  background: #f6f7f8;
  height: calc(100% - 67px);
} */
.lv1-row2 .main-content {
  height: calc(100% - 15px) !important;
  min-height: auto !important;
  overflow: hidden !important;
  padding: 68px 15px 0px 88px;
  background: #f6f7f8;
}

/* Left Nav */
/* Common */
.side-nav .ob__Img {
  float: left;
  transform: translateY(-4px);
}

.side-nav .ob__Img+.nav-label {
  float: left;
  padding: 12px 0px 16px 10px;
}

.side-nav li a:hover .nav-label,
.side-nav li.active a .nav-label {
  background: transparent;
  color: #143361;
}

.side-nav li.active a,
.side-nav a:hover {
  border-left: 4px solid #163460;
  background-image: linear-gradient(to right, #8192af, #c4c3c8);
  border-right: 4px transparent;
}

/* Dashboard */
.side-nav .ob-dashboard__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Dashboard.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-dashboard__Img,
.side-nav a:hover .ob-dashboard__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Dashboard-selected.svg") no-repeat center 20px/18px auto;
}

/* Profile */
.side-nav .ob-profile__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_profile.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-profile__Img,
.side-nav a:hover .ob-profile__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_profile-selected.svg") no-repeat center 20px/18px auto;
}

/* Mail */
.side-nav .ob-mail__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Mail.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-mail__Img,
.side-nav a:hover .ob-mail__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Mail-selected.svg") no-repeat center 20px/18px auto;
}

/* WorkForce */
.side-nav .ob-workforce__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Workforce.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-workforce__Img,
.side-nav a:hover .ob-workforce__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Workforce-selected.svg") no-repeat center 20px/18px auto;
}

/* Evaluation */
.side-nav .ob-evaluation__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_tasks.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-evaluation__Img,
.side-nav a:hover .ob-evaluation__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_tasks-selected.svg") no-repeat center 20px/18px auto;
}

/* Timesheets */
.side-nav .ob-timesheets__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_timesheets.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-timesheets__Img,
.side-nav a:hover .ob-timesheets__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_timesheets-selected.svg") no-repeat center 20px/18px auto;
}

/* leave-management */
.side-nav .ob-leave-management__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_leave-management-selected.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-leave-management__Img,
.side-nav a:hover .ob-leave-management__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_leave-management.svg") no-repeat center 20px/18px auto;
}

/* Calendar */
.side-nav .ob-calendar__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Calendar.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-calendar__Img,
.side-nav a:hover .ob-calendar__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Calendar-selected.svg") no-repeat center 20px/18px auto;
}

/* Form i9s */
.side-nav .ob-FormI9s__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_I9repository.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-FormI9s__Img,
.side-nav a:hover .ob-FormI9s__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_I9repository-selected.svg") no-repeat center 20px/18px auto;
}

/* LCA */
.side-nav .ob-lca__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_LCAlisting.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-lca__Img,
.side-nav a:hover .ob-lca__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_LCAlisting-selected.svg") no-repeat center 20px/18px auto;
}

/* FDNS */
.side-nav .ob-fdns__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_FDNS.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-fdns__Img,
.side-nav a:hover .ob-fdns__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_FDNS.svg") no-repeat center 20px/18px auto;
}

/* Help */
.side-nav .ob-help__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_help.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-help__Img,
.side-nav a:hover .ob-help__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_help.svg") no-repeat center 20px/18px auto;
}

/* Send Feedback */
.side-nav .ob-send-feedback__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_sendfeedback.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-send-feedback__Img,
.side-nav a:hover .ob-send-feedback__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/ic_sendfeedback.svg") no-repeat center 20px/18px auto;
}

/* Settings */
.side-nav .ob-settings__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Settings.svg") no-repeat center 20px/18px auto;
}

.side-nav li.active a .ob-settings__Img,
.side-nav a:hover .ob-settings__Img {
  background: url("#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/base-layout/top-left-nav_Icons/Ic_Settings-selected.svg") no-repeat center 20px/18px auto;
}

/* Side bar layout style update */
.side-bar {
  position: relative;
}

.side-nav ul.top,
.side-nav ul.bottom {
  position: absolute;
  height: auto;
}

.side-nav ul.top {
  top: 5px;
}

.side-nav ul.bottom {
  width: 100%;
  bottom: 80px;
}

/* Side bar bottom icons hover effect override */
.side-nav ul.bottom li.active a,
.side-nav ul.bottom a:hover {
  width: 70px;
  background: #c4c3c8;
  border-color: #c4c3c8;
}

/* auto height */
/* Mainly for the HR Dashboard where the height will be auto */
body.height-auto {
  height: auto !important;
  overflow: auto;
  background: #f6f7f8;
}

body.height-auto .lv1-row2 .main-content {
  height: auto;
}

.side-nav li a:hover {
  width: 230px;
}

.side-nav .reportingClass a:hover {
  width: 300px;
}

/* .reportingClass :hover{
  width: 300px;
} */
.org {
  padding: 11px 2px 18px;
}

.org-icon {
  float: left;
  padding-right: 10px;
}

.org-text {
  color: #143361;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
}

.select-org {
  cursor: pointer;
}

.logOut--headerSec.middle {
  padding: 0;
}

.logOut--SettingNoBDR:hover {
  color:crimson  /* Change to the color you want on hover */
}


/* .logOut--SettingNoBDR {
  margin-right: 25px;
} */
.logOut--headerSec.middle a span {
  background: none;
}

.logOut--headerSec .Alert--fill.show-notification-count {
  display: inline;
}

.pop-para {
  text-align: left;
}

/* .logOut--SettingR{
      border-right: none;
} */

.v-fade-left-enter-active,
.v-fade-left-leave-active,
.v-fade-left-move {
  transition: all 0.5s;
}

.v-fade-left-enter,
.v-fade-left-leave-to {
  opacity: 0;
  transform: translateX(-500px) scale(0.2);
}

.notification-wrapper {
  overflow: visible !important;
}

.vue-notification-wrapper {
  overflow: visible !important;
}
</style>
<style lang="scss" scoped>
.popper {
  text-align: left;
  margin-left: 2%;

}
.popTop{
  top: 13px !important;
}
.popOrg{
  width: auto !important;
}
.popper-section {
  padding: 5px;
}

.popper-section ul+ul {
  border-top: 1px solid #dcdcdc;
}

.switch-role-list {
  cursor: pointer;
  text-align: left;
  padding: 3px 3px;
  font-size: 14px;
  color: #707070;
  font-weight:600;
}

.switch-role-list-popover{
  cursor: pointer;
  text-align: left;
  font-size: 12px;
  color: #212121;
  font-weight: 500;
}

.switch-role-list-popover:hover{
  color: #ef032e;
}

.switch-role-list:hover {
  color: #ef032e;
}
.cmp{
  color:#dcdcdc ;
  font-size: 11px;
}
.cmpdetails{
  float: left;
  padding-left: 0.4%;
  width: 28%;
}
.textt{
  max-width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  padding-top: 12px;
  padding-left: 5px;
  color: white;
  cursor: pointer;
}
.logodetail{
  float: left;
  width: 41%;
}
.leftdetail{
  float: right;
  width: 20%;
  justify-content: flex-end;
  display: flex;
}
.namedetail{
  float: right;
  display: inline-block;
}
.profilepics{
  width: 37px;
  display: block;
  padding-top: 5%;
}
.picc{
  border-radius: 100%;
  height: 32px;
  width: 32px;
  margin-top: 1px;
}
.nameDesignation{
  cursor:pointer;

  padding-top: 8%;
  background: #2E2E3B;
  color: white;
}
.ellipsis-designtn{
  text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 91px;
    overflow: hidden;
}
.ellipsis-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90px;
  overflow: hidden;
  display: inline-block;
}
.anchordetail{
  display: block;
  color: #fff;
  height: 51px;
}
.pics{
  border-radius: 100%;
  height: 32px;
  width: 32px;
  margin-top: 7px;
  margin-left: 3px;
  display: inline-block;
  float: left;
}

.switch-role-popup.role-change-sucess .switch-change-icon {
  width: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseLayout.vue